import { render, staticRenderFns } from "./rollingNumber.vue?vue&type=template&id=578fb672&scoped=true"
import script from "./rollingNumber.vue?vue&type=script&lang=js"
export * from "./rollingNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fb672",
  null
  
)

export default component.exports